import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  signal
} from "@angular/core";
import { InfoCardTypesEnum } from "src/app/classes/enums";
import { IconService } from "src/app/services/icon.service";

import { IconComponent } from "../icon/icon.component";

@Component({
  selector: "app-info-card",
  templateUrl: "./info-card.component.html",
  styleUrl: "./info-card.component.scss",
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoCardComponent implements OnInit {
  collapsed = signal(!!(window.innerWidth < 992));
  isMobile = signal(!!(window.innerWidth < 992));

  header = input<string | undefined>();
  body = input<string>();
  icon = input<string>();
  type = input<InfoCardTypesEnum | undefined>();
  toggler = input(true);
  alwaysOpen = input<boolean>(false);

  InfoCardTypesEnum = InfoCardTypesEnum;

  constructor(public iconService: IconService) {}

  ngOnInit(): void {}

  onToggle(): void {
    this.isMobile.set(false);
    this.collapsed.update((c) => !c);
  }
}
